import DateUtils from "@date-io/date-fns";
import {
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	TextField,
} from "@material-ui/core";
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
// import Axios from "axios";
import "date-fns/locale/pt-BR";
import moment from "moment";
import React, { forwardRef, useImperativeHandle, useState } from "react";
// import config from "react-global-configuration";
import { toast } from "react-toastify";
import CondicoesPagamento from "../Orcamentos/Forms/CondicoesPagamento";
import Parcelas from "../Orcamentos/Forms/Parcelas";
import Vendedor from "../Orcamentos/Forms/Vendedor";

const AceiteDadosPagamento = forwardRef((props, ref) => {
	const [formData, setFormData] = useState({
		dEntrega: "",
		dEmissao: moment().add(1, "d").format("YYYY-MM-DD"),
		cEmailBoleto: props.data.orcamento.consultor_email,
		cMontagem: "N",
		cObservacao: "",
		motivoSubstituicao: "",
		cBanco: props.data.bancos.length > 0 ? props.data.bancos[0].id : null,
	});

	const [installmentsData, setInstallmentsData] = useState([]);
	const [minDate, setMinDate] = useState(
		moment().add(1, "d").format("YYYY-MM-DD")
	);
	const [refreshPaymentTerms, setRefreshPaymentTerms] = useState(false);
	const [loadingRefreshPaymentTerms, setLoadingRefreshPaymentTerms] =
		useState(false);

	useImperativeHandle(ref, () => ({
		advanceHandler() {
			return save();
		},
	}));

	const aplicaParcelasFormaPagamento = (data) => {
		setInstallmentsData(data);
	};

	const save = () => {
		props.setLoading(true);

		if (moment(formData.dEntrega).diff(moment(), "days") <= 0) {
			toast.error("Verifique a data de entrega");
			props.setLoading(false);
			return false;
		}
		// verifica dEmissao
		if (!moment(formData["dEmissao"], "YYYY-MM-DD", true).isValid()) {
			toast.error("Informe a data de emissão");
			props.setLoading(false);
			return false;
		}
		// verifica cCondicaoPagamento
		if (
			!formData["cCondicaoPagamento"] ||
			formData["cCondicaoPagamento"] === ""
		) {
			toast.error("Informe a condição de pagamento");
			props.setLoading(false);
			return false;
		}

		// verifica dEntrega
		if (!moment(formData["dEntrega"], "YYYY-MM-DD", true).isValid()) {
			toast.error("Informe a data de entrega");
			props.setLoading(false);
			return false;
		}

		// verifica cEmailBoleto
		if (!formData["cEmailBoleto"] || formData["cEmailBoleto"] === "") {
			toast.error("Informe o email do boleto");
			props.setLoading(false);
			return false;
		}

		// verifica cEmailBoleto
		if (!formData["cVendedor"] || formData["cVendedor"] === "") {
			toast.error("Informe o vendedor");
			props.setLoading(false);
			return false;
		}

		// verifica parcelas com o total do pedido
		const sum = installmentsData.reduce(function (accumulator, item) {
			return accumulator + parseFloat(item.nValor);
		}, 0);

		const quoteTotal = parseFloat(props.data.orcamento.total_com_desconto);
		if (sum.toFixed(2) !== quoteTotal.toFixed(2)) {
			toast.error(
				"A soma das parcelas não é igual ao total do pedido. Total do pedido " +
					quoteTotal.toFixed(2) +
					", total das parcelas " +
					sum.toFixed(2)
			);
			props.setLoading(false);
			return false;
		}

		// let totalProdutos = 0;
		// let totalParcelas = 0;

		const produtos = props.data.produtos.map((produto) => {
			return {
				cProduto: produto.cProduto,
				nQuantidade: produto.nQuantidade,
				dEntrega: moment(formData.dEntrega).format("YYYYMMDD"),
				nValorNegociado: parseFloat(produto.nValorVenda),
			};
		});

		const pad = (n, width, z) => {
			z = z || "0";
			n = n + "";
			return n.length >= width
				? n
				: new Array(width - n.length + 1).join(z) + n;
		};

		const parcelas = installmentsData.map((parcela, i) => {
			// totalParcelas += parseFloat(parcela.nValor);
			return {
				dVencimento: moment(parcela.dVencimento).format("YYYYMMDD"),
				cParcela: pad(i + 1, 3),
				CTIPO: parcela.cTipo,
				nValor: parseFloat(parcela.nValor),
			};
		});

		const formDataSend = {
			cTipoContrato: "2",
			cOrigem: "0800",
			cBanco: formData.cBanco,
			cIdExterno: "",
			cCIP: documentoPrincipal(),
			cCondicaoPagamento: formData.cCondicaoPagamento,
			cVendedor: formData.cVendedor,
			cVendedor5: props.data.vendedor.cCodigo,
			nCustoFinanceiro: 0,
			cObservacao: formData.cObservacao,
			cMontagem: formData.cMontagem,
			cEmailBoleto: formData.cEmailBoleto,
			nOrcamento: parseInt(props.data.orcamento.numero),
			cPedidoCliente: "",
			cAplicacao: "APIZAFFAR",
			aItem: produtos,
			aParcela: parcelas,
			nFrete: 0,
			nPrazoExpedicao: moment(formData.dEntrega).diff(moment(), "days"),
			cCodigo:
				props.data.cliente && props.data.cliente.cCodigo
					? props.data.cliente.cCodigo
					: "",
			motivoSubstituicao: formData.motivoSubstituicao,
		};

		props.setPeidoTotvs(formDataSend);
		props.setLoading(false);
		props.forceNext();
		// console.log(formDataSend);
		// Axios.post(
		// 	config.get("url_api") +
		// 		"orcamento/salvar-dados-pedido/" +
		// 		props.data.orcamento.id,
		// 	formDataSend
		// )
		// 	.then(function (response) {
		// 		// console.log("response", response);
		// 		if (response.status === 200) {
		// 			if (!response.data.success) {
		// 				toast.error(response.data.mensagem);
		// 				props.setLoading(false);
		// 				// props.forceNext();
		// 				return true;
		// 			} else {
		// 				props.setLoading(false);
		// 				props.forceNext();
		// 				return true;
		// 			}
		// 		} else {
		// 			toast.error("Erro ao enviar dados.");
		// 			props.setLoading(false);
		// 			return true;
		// 		}
		// 	})
		// 	.catch(function (error) {
		// 		toast.error("Erro:" + error);
		// 		props.setLoading(false);
		// 	});
	};

	const documentoPrincipal = () => {
		if (props.cliente.tipo_consumidor === "X") {
			return props.cliente.rg;
		}
		if (props.cliente.tipo_consumidor === "R") {
			return props.cliente.cnpj ? props.cliente.cnpj : props.cliente.cpf;
		}
		if (props.cliente.tipo_consumidor === "F") {
			return props.cliente.cpf ? props.cliente.cpf : props.cliente.cnpj;
		}
	};

	const inputHandler = (field, value) => {
		setFormData({ ...formData, [field]: value });

		if (field == "dEmissao") {
			setRefreshPaymentTerms(!refreshPaymentTerms);
		}
	};

	const motivoSubstituicaoHandler = (field, e) => {
		setFormData({ ...formData, [field]: e.target.value });
	};

	const aplicaParcelas = (dados) => {
		// console.log("---------------->");
		// console.log("Aplica Parcelas");
		// console.log("dados entrada", dados);
		let data = [];
		const parcelas = dados.cCondicaoPagamentoParcelas.length;

		let soma = 0;
		if (
			props.data.orcamento.entrada > 0 &&
			dados.cCondicaoPagamentoParcelas.length > 1
		) {
			// console.log("Tem entrada");
			// console.log("calcula parcelas com entrada");
			data.push({
				cParcela: "Entrada",
				dVencimento: dados.cCondicaoPagamentoParcelas[0]["dVencimento"],
				cTipo: "CC",
				nValor: arredonda(props.data.orcamento.entrada),
			});
			soma += arredonda(props.data.orcamento.entrada);
			// console.log("parcelas", parcelas);
			let i = 1;
			for (i = 1; i < parcelas - 1; i++) {
				const parcela = arredonda(
					(props.data.orcamento.total_com_desconto -
						props.data.orcamento.entrada) /
						(parcelas - 1)
				);
				data.push({
					cParcela: i,
					dVencimento: dados.cCondicaoPagamentoParcelas[i]["dVencimento"],
					cTipo: "CC",
					nValor: parcela,
				});
				soma += parcela;
			}

			const parcelaFinal = arredonda(
				arredonda(props.data.orcamento.total_com_desconto) - arredonda(soma)
			);

			data.push({
				cParcela: parcelas - 1,
				dVencimento:
					dados.cCondicaoPagamentoParcelas[parcelas - 1]["dVencimento"],
				cTipo: "CC",
				nValor: parcelaFinal,
			});
		} else {
			// console.log("Não tem entrada");
			let soma = 0;
			for (let i = 0; i < parcelas - 1; i++) {
				const parcela = arredonda(
					props.data.orcamento.total_com_desconto / parcelas
				);
				soma += parcela;

				data.push({
					cParcela: i + 1,
					dVencimento: dados.cCondicaoPagamentoParcelas[i]["dVencimento"],
					cTipo: "CC",
					nValor: parcela,
				});
			}

			const parcelaFinal = arredonda(
				arredonda(props.data.orcamento.total_com_desconto) - arredonda(soma)
			);

			data.push({
				cParcela: parcelas,
				dVencimento:
					dados.cCondicaoPagamentoParcelas[parcelas - 1]["dVencimento"],
				cTipo: "CC",
				nValor: parcelaFinal,
			});
		}

		// console.log("data", data);
		// console.log("---------------->");

		const dia =
			dados.cCondicaoPagamentoParcelas[
				dados.cCondicaoPagamentoParcelas.length - 1
			]["dVencimento"];

		setMinDate(moment(dia).add(1, "d").format("YYYY-MM-DD"));

		setFormData({
			...formData,
			dEntrega: moment(dia).add(45, "d").format("YYYY-MM-DD"),
			cCondicaoPagamentoParcelas: dados.cCondicaoPagamentoParcelas,
			cCondicaoPagamento: dados.cCondicaoPagamento,
		});

		setInstallmentsData(data);
	};

	const arredonda = (valor) => {
		try {
			valor = parseFloat(valor);
		} catch (error) {
			return valor;
		}
		return Math.round(valor * 100) / 100;
	};

	const BancosItens = () => {
		const itens = props.data.bancos.map((item, i) => {
			return (
				<MenuItem key={i} value={item.id}>
					{item.nome}
				</MenuItem>
			);
		});
		return itens;
	};
	return (
		<React.Fragment>
			<Grid container spacing={3}>
				<Grid item md={3}>
					<Paper className="p-1">
						{props.data && props.data.orcamento.substituiu && (
							<FormControl fullWidth>
								<InputLabel id="motivoSubstituicao-label">
									Motivo da substituição
								</InputLabel>
								<Select
									id="motivoSubstituicao"
									value={formData.motivoSubstituicao}
									onChange={(e) =>
										motivoSubstituicaoHandler(["motivoSubstituicao"], e)
									}
								>
									<MenuItem value={"ALTERAR COR"}>ALTERAR COR</MenuItem>
									<MenuItem value={"ALTERAR ITENS"}>ALTERAR ITENS</MenuItem>
									<MenuItem value={"ALTERAR VENDEDOR"}>
										ALTERAR VENDEDOR
									</MenuItem>
									<MenuItem value={"CONDIÇÃO DE PAGAMENTO"}>
										CONDIÇÃO DE PAGAMENTO
									</MenuItem>
									<MenuItem value={"ERRO DE DIGITACAO"}>
										ERRO DE DIGITAÇÃO
									</MenuItem>
									<MenuItem value={"ERRO SISTEMICO"}>ERRO SISTEMICO</MenuItem>
									<MenuItem value={"MUDANÇA DE TITULAR"}>
										MUDANÇA DE TITULAR
									</MenuItem>
									<MenuItem value={"PEDIDO DESMEMBRADO"}>
										PEDIDO DESMEMBRADO
									</MenuItem>
								</Select>
							</FormControl>
						)}
						<Vendedor
							formData={formData}
							setFormData={setFormData}
							vendedorRemover={props.data.vendedor.cNome}
						/>
						<MuiPickersUtilsProvider utils={DateUtils}>
							<KeyboardDatePicker
								fullWidth
								autoOk
								disablePast
								variant="dialog"
								margin="normal"
								format="dd/MM/yyyy"
								id="date-picker-inline"
								label="Data de emissão"
								autoComplete={"off"}
								value={formData["dEmissao"]}
								error={formData["dEmissao"] === ""}
								placeholder={"Informe a data de emissão"}
								onChange={(e) => inputHandler(["dEmissao"], e)}
							/>

							<CondicoesPagamento
								formData={formData}
								setFormData={setFormData}
								aplicaParcelas={aplicaParcelas}
								refreshPaymentTerms={refreshPaymentTerms}
								loadingRefresh={setLoadingRefreshPaymentTerms}
							/>
							<KeyboardDatePicker
								minDate={minDate}
								fullWidth
								autoOk
								disablePast
								variant="dialog"
								margin="normal"
								format="dd/MM/yyyy"
								id="date-picker-inline"
								label="Data de expedição"
								autoComplete={"off"}
								value={
									formData["dEntrega"] !== "" ? formData["dEntrega"] : null
								}
								error={formData["dEntrega"] === ""}
								placeholder={"Informe a data de expedição"}
								onChange={(e) => inputHandler(["dEntrega"], e)}
							/>
						</MuiPickersUtilsProvider>
						<TextField
							id={"cEmailBoleto"}
							label={"Email boleto"}
							error={false}
							type={"text"}
							margin="dense"
							autoComplete="off"
							fullWidth
							required
							value={
								formData && formData["cEmailBoleto"]
									? formData["cEmailBoleto"]
									: ""
							}
							onChange={(e) => inputHandler(["cEmailBoleto"], e.target.value)}
							inputProps={{
								maxLength: 40,
							}}
						/>

						<TextField
							id={"cObservacao"}
							label={"Observações"}
							type={"text"}
							margin="dense"
							autoComplete="off"
							fullWidth
							multiline
							value={
								formData && formData["cObservacao"]
									? formData["cObservacao"]
									: ""
							}
							onChange={(e) => inputHandler(["cObservacao"], e.target.value)}
						/>

						<TextField
							label={"Vendedor 2"}
							type={"text"}
							margin="dense"
							autoComplete="off"
							fullWidth
							value={props.data.vendedor.cNome}
							inputProps={{
								readOnly: true,
							}}
						/>

						<FormControl fullWidth>
							<InputLabel>Banco</InputLabel>
							<Select
								fullWidth
								value={formData && formData["cBanco"] ? formData["cBanco"] : ""}
								onChange={(e) => inputHandler(["cBanco"], e.target.value)}
							>
								{BancosItens()}
							</Select>
						</FormControl>
					</Paper>
				</Grid>
				<Grid item md={9}>
					<Parcelas
						installmentsData={installmentsData}
						setInstallmentsData={aplicaParcelasFormaPagamento}
						orcamento={props.data.orcamento}
						setMinDate={setMinDate}
						setFormData={setFormData}
						formData={formData}
						loadingRefresh={loadingRefreshPaymentTerms}
					/>
				</Grid>
			</Grid>
		</React.Fragment>
	);
});

export default AceiteDadosPagamento;
